import { render, staticRenderFns } from "./sensor.vue?vue&type=template&id=9d908d12&scoped=true&"
import script from "./sensor.vue?vue&type=script&lang=js&"
export * from "./sensor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d908d12",
  null
  
)

export default component.exports